export default function SystemSentimentIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_41066_13472'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_41066_13472)'>
        <path
          d='M7.49917 21.423V16.5H2.57617V7.50003H7.49917V2.57703H16.4992V7.50003H21.4222V16.5H16.4992V21.423H7.49917ZM4.07617 11.25H8.99917C9.12734 11.25 9.24559 11.2804 9.35392 11.3413C9.46225 11.4023 9.54851 11.4834 9.61267 11.5848L10.7762 13.3173L12.2897 8.77703C12.3435 8.62186 12.4338 8.49528 12.5607 8.39728C12.6877 8.29911 12.8332 8.25003 12.9972 8.25003C13.1235 8.25003 13.2435 8.28103 13.3572 8.34303C13.4707 8.40503 13.559 8.48561 13.6222 8.58478L15.3894 11.25H19.9222V9.00003H14.9992V4.07703H8.99917V9.00003H4.07617V11.25ZM8.99917 19.923H14.9992V15H19.9222V12.75H14.9992C14.874 12.75 14.7551 12.7181 14.6424 12.6543C14.5298 12.5906 14.4358 12.5078 14.3607 12.4058L13.2222 10.6828L11.7087 15.223C11.6548 15.3782 11.5603 15.5048 11.4252 15.6028C11.2898 15.7009 11.1393 15.75 10.9734 15.75C10.8458 15.75 10.7278 15.7196 10.6194 15.6588C10.5111 15.5978 10.4248 15.5166 10.3607 15.4153L8.58392 12.75H4.07617V15H8.99917V19.923Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
